/*
NAME: ChartPeriod
DESC: 
props:
- title: string, titulo do grafico
- limit: number, limite de valores
- items: array de objetos: {
      - date: objeto tipo new Date,
      - value: number, a quantidede respectiva nessa data
   }
- onFilterChange: function, callback para quando o filtro for alterado, retornando para o parent o objeto do filtro selecionado
- - - - Default
- style: Object, style object to overwrite this component style
NOTES:
Lembrar de alterar o filter.value quando o padrão do objeto for definido
*/
import { Typography, Stack } from "@mui/material";
import { useState, useEffect } from "react";
import values from "../../values/values";
import MenuList2 from "./MenuList2";
import ProjectChart from "./ProjectChart";
import strings from "../../values/strings/strings";
import { propsToClassKey } from "@mui/styles";

function ChartPeriod({title, limit, items, onFilterChange, style, width}) {
   const [filters, setFilters] = useState(values.TIME_FILTERS);
   const [ chartData, setchartData] = useState([])
   

   useEffect(() =>{
      if(items) {
         const processedData = items.map((item) => ({
            date: new Date(item.date),
            value: item.value,
            title: item.title
         }));
         setchartData(processedData);
      }
   }, [items] );
 
   return (
      <Stack style={{
         display: 'flex', 
         flexWrap: 'wrap', 
         padding: values.padding[10], 
         ...style
     }}>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>        
            <MenuList2 
                  items={values.TIME_FILTERS} 
                  value= {strings.getString('info_filtro')} 
                  onSelect={(selected) => onFilterChange(selected)}
               /> 
        </div>
         
        <ProjectChart data={chartData} title={title} width={width}/>
      </Stack>
   );
}

export default ChartPeriod;